import React from 'react';
import { Col, Form, Row } from 'react-bootstrap';
import AwareButton from '../../components/button';
import { EmailIcon, PhoneIcon } from '../../components/icons';

/**
 * CustomerInfoCard Component
 * Displays customer address, license, and contact information
 * Memoized to prevent unnecessary re-renders
 */
const CustomerInfoCard = React.memo(({ customer }) => {
    if (!customer || !Object.keys(customer).length) {
        return null;
    }

    return (
        <>
            <h4 className='mb-3'>Payment Pickup Information</h4>
            <div className='check-card'>
                <Row>
                    <Col md={6} xs={12}>
                        <Form.Group className='form-group'>
                            <Form.Label className='mb-2'>
                                Address
                            </Form.Label>
                            <div className='form-group-content'>
                                <p>{customer.AddressLine1}</p>
                                <p>
                                    {customer.City}, {customer.State}{' '}
                                    {customer.PostalCode}
                                </p>
                            </div>
                        </Form.Group>
                    </Col>
                    <Col md={6} xs={12}>
                        <Form.Group className='form-group'>
                            <Form.Label className='mb-2'>
                                License Number
                            </Form.Label>
                            <div className='form-group-content'>
                                <p>{customer['LIC#1: Primary License']}</p>
                            </div>
                        </Form.Group>
                    </Col>
                </Row>
            </div>
        </>
    );
});

CustomerInfoCard.displayName = 'CustomerInfoCard';

/**
 * ContactRepCard Component
 * Displays contact buttons for calling or emailing the representative
 * Memoized to prevent unnecessary re-renders
 */
const ContactRepCard = React.memo(({ customer }) => {
    if (!customer || !Object.keys(customer).length) {
        return null;
    }

    return (
        <>
            <h4 className='mb-3'>
                Please contact your rep with any additional notes
            </h4>
            <div className='check-card'>
                <div className='submit-group'>
                    <AwareButton
                        className='btn me-3 btn-secondary second'
                        href={`tel:${customer['IA:Representative Phone']}`}
                    >
                        <PhoneIcon />
                        Call Rep
                    </AwareButton>
                    <AwareButton
                        className='btn btn-secondary second'
                        href={`mailto:${customer['IA:Representative Email']}`}
                    >
                        <EmailIcon />
                        Email Rep
                    </AwareButton>
                </div>
            </div>
        </>
    );
});

ContactRepCard.displayName = 'ContactRepCard';

export { CustomerInfoCard, ContactRepCard };

